
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { HighlightPositionType, highlightClass, TeaConfig } from '@/const/creative'
import { captureError } from '@/utils/errorLogger'

const highlightRerender = 'highlight-rerender'

@Component({
  name: 'Highlight',
})
export default class Highlight extends Vue {
  show = false;
  position: HighlightPositionType = HighlightPositionType.left;
  HighlightPositionType = HighlightPositionType;

  @Prop({ required: true }) readonly el: Element // 需要高亮提示关注的页面结点
  @Prop({ required: true }) readonly hint: string // 高亮提示内容key
  @Prop({ default: '' }) readonly storeKey: string // localstorage对应key，没有storeKey表示highlight提示一直会出现
  @Prop({ default: true }) readonly canShow: boolean // highlight调用处自定义是否允许展示，否则仅判断当前设备当前aadvid是否有展示过
  @Prop({ default: '' }) readonly customPosition: HighlightPositionType // 气泡位置

  @State((state) => state.account.accountInfo.id) aadvid: string

  mounted(): void {
    // 针对需要高亮的节点是静态节点的处理
    this.handleHighlight()
  }

  // 针对需要高亮的节点是动态节点的处理
  @Watch('show')
  handleShow(val: boolean): void {
    if (val) {
      this.$subscribe(highlightRerender, () => {
        if (this.el) {
          this.handleHighlight()
        }
      })
    } else {
      // 由于highlight是组件内一个show变量，组件外引用还有另外一个show变量，当外部show为true，内部show为false时也需要取消订阅
      this.$unSubscribe(highlightRerender)
    }
  }

  beforeDestroy(): void {
    this.$unSubscribe(highlightRerender)
  }

  handleHighlight() {
    if (!this.storeKey) {
      this.show = true
    } else if (this.canShow && localStorage.getItem(this.storeKey) !== this.aadvid) {
      // 只给自助&&没创建过ad的用户提示
      this.show = true
      localStorage.setItem(this.storeKey, this.aadvid)
    }
    if (!this.show) {
      return
    }
    this.$nextTick(() => {
      this.renderHighlight()
    })
  }

  renderHighlight() {
    if (!this.el) {
      // 动态节点逻辑会执行到此处，无需手动上报
      // captureError(new Error('highlight element not found'));
      this.show = false
      return
    }

    try {
      this.el.classList.add(highlightClass)
      const rect = this.el.getBoundingClientRect()
      const padding = 16
      const screenWidth = window.screen.width
      const {tipsHint: tipsHintEl, tipsTriangle: tipsTriangleEl} = this.$refs

      // TODO-kad 超出边界的情况还需要考虑
      if (this.customPosition) this.position = this.customPosition
      else if (rect.left >= 0 && rect.left < screenWidth / 3) {
        this.position = HighlightPositionType.left
      } else {
        this.position = HighlightPositionType.right
      }

      let top = +rect.bottom + padding
      let left = this.position === HighlightPositionType.left ? rect.left : (rect.right - tipsHintEl.clientWidth)
      if (this.position === HighlightPositionType.top) {
        top = +rect.top - tipsHintEl.clientHeight - padding
        left = 20
      }

      tipsHintEl.style.top = `${top}px`
      tipsHintEl.style.left = `${left}px`

      switch (this.position) {
        case HighlightPositionType.left:
          tipsTriangleEl.style.left = `${padding}px`
          break
        case HighlightPositionType.right:
          tipsTriangleEl.style.right = `${padding}px`
          break
        case HighlightPositionType.top:
          tipsTriangleEl.style.left = "50%"
          tipsTriangleEl.style.top = `${tipsHintEl.clientHeight}px`
          tipsTriangleEl.style.transform = 'rotate(180deg) translateX(50%)'
      }

      if (TeaConfig[`highlight-${this.storeKey}`]) {
        this.$trackEvent('adp_waplite_impression', TeaConfig[`highlight-${this.storeKey}`])
      }

    } catch (e) {
      this.show = false
      captureError(e)
    }
  }

  handleClose(): void {
    this.show = false
    this.el.classList.remove(highlightClass)
    this.$emit('close')
  }
}
